import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const ralColorPickerK = {
  searchPlaceholder: "ral_color_picker.searchPlaceholder",
  dialogTitle: "ral_color_picker.dialogTitle",
  noResultsFound: "ral_color_picker.noResultsFound",
  recentColors: "ral_color_picker.recentColors",
  noColorSelected: "ral_color_picker.noColorSelected",
};

export const useRalColorPickerT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      searchPlaceholder: t(ralColorPickerK.searchPlaceholder),
      dialogTitle: t(ralColorPickerK.dialogTitle),
      noResultsFound: t(ralColorPickerK.noResultsFound),
      recentColors: t(ralColorPickerK.recentColors),
      noColorSelected: t(ralColorPickerK.noColorSelected),
    }),
    [i18n.language]
  );
};